import * as tslib_1 from "tslib";
// Core components
import { ChangeDetectorRef, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatInput } from '@angular/material';
import { DateAdapter, MatDateFormats } from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';
import { FieldType } from '@ngx-formly/material';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
export var MY_FORMATS = {
    parse: {
        dateInput: 'DD/MM',
    },
    display: {
        dateInput: 'DD/MM',
        monthYearLabel: 'MMM',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};
/** @title Datepicker with custom calendar header */
var DayMonthPickerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DayMonthPickerComponent, _super);
    function DayMonthPickerComponent() {
        var _this = _super.call(this) || this;
        _this.dayMonthPickerHeader = DayMonthPickerHeaderComponent;
        return _this;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    DayMonthPickerComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    /**
     * After view init logic
     *
     * @since 1.0.0
     */
    DayMonthPickerComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    /**
    * Listen for @Input changes
    *
    * @since 1.0.0
    */
    DayMonthPickerComponent.prototype.ngOnChanges = function (changes) {
        // console.log("changes", changes)
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    DayMonthPickerComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
    };
    return DayMonthPickerComponent;
}(FieldType));
export { DayMonthPickerComponent };
/** Custom header component for datepicker. */
var DayMonthPickerHeaderComponent = /** @class */ (function () {
    function DayMonthPickerHeaderComponent(_calendar, _dateAdapter, _dateFormats, cdr) {
        this._calendar = _calendar;
        this._dateAdapter = _dateAdapter;
        this._dateFormats = _dateFormats;
        this._destroyed = new Subject();
        _calendar.stateChanges
            .pipe(takeUntil(this._destroyed))
            .subscribe(function () { return cdr.markForCheck(); });
    }
    DayMonthPickerHeaderComponent.prototype.ngOnDestroy = function () {
        this._destroyed.next();
        this._destroyed.complete();
    };
    Object.defineProperty(DayMonthPickerHeaderComponent.prototype, "periodLabel", {
        get: function () {
            return this._dateAdapter
                .format(this._calendar.activeDate, this._dateFormats.display.monthYearLabel)
                .toLocaleUpperCase();
        },
        enumerable: true,
        configurable: true
    });
    DayMonthPickerHeaderComponent.prototype.previousClicked = function (mode) {
        this._calendar.activeDate = this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1);
    };
    DayMonthPickerHeaderComponent.prototype.nextClicked = function (mode) {
        this._calendar.activeDate = this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1);
    };
    return DayMonthPickerHeaderComponent;
}());
export { DayMonthPickerHeaderComponent };
